import { lazy } from "react"
import { SummaryTiming } from "slot-definitions"

const ScheduleTiming = lazy(() => import("./schedule-timing"))
SummaryTiming.plug(<ScheduleTiming noContainer />)
